import { render, staticRenderFns } from "./SupportNavbarBtn.vue?vue&type=template&id=89803886&"
import script from "./SupportNavbarBtn.vue?vue&type=script&lang=ts&"
export * from "./SupportNavbarBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports